function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Callout from "@churchofjesuschrist/eden-callout";
import { grey3, grey15, spacing4, spacing8, spacing16 } from "@churchofjesuschrist/eden-style-constants";
import Fade from "@churchofjesuschrist/eden-fade";
import Footer from "./components/Footer";
import { useHasOverflow } from "@churchofjesuschrist/eden-has-overflow";
const StyledCallout = styled(Callout).withConfig({
  componentId: "sc-80kb9u-0"
})(["width:100%;max-width:17.5rem;max-height:min(37.5rem,100vh);display:flex;flex-direction:column;& hr{height:1px;background-color:", ";border:none;margin:0;}& legend{padding:calc(", " + ", ") ", " ", ";}&&& label{display:flex;padding:calc(", " + ", ") ", ";justify-content:space-between;}&&& fieldset{display:block;& label{justify-content:flex-start;}}& label:hover{background:", ";cursor:pointer;}& input:is([type=\"checkbox\"],[type=\"radio\"]){cursor:pointer;}"], grey15, spacing8, spacing4, spacing16, spacing8, spacing8, spacing4, spacing16, grey3);

/**
 * Use a contextual menu to display a list of links/actions that can be toggled on/off.
 * While similar to eden-callout, this component adds styling to accommodate eden-form-parts.
 */
const ContextualMenu = _ref => {
  let {
    forRef,
    children,
    open,
    arrow = "overlay",
    onClickOutside,
    footer,
    ...props
  } = _ref;
  const [overflowRef, {
    hasY,
    hasTop,
    hasBottom
  }] = useHasOverflow(open);
  return /*#__PURE__*/React.createElement(StyledCallout, _extends({
    forRef: forRef,
    open: open,
    onClickOutside: onClickOutside,
    arrow: arrow
  }, props), /*#__PURE__*/React.createElement(Fade, {
    style: {
      overflow: "auto"
    },
    active: hasY && !!(overflowRef !== null && overflowRef !== void 0 && overflowRef.current),
    to: hasTop && hasBottom ? "topBottom" : hasTop ? "top" : "bottom",
    ref: overflowRef
  }, children), footer ? /*#__PURE__*/React.createElement(Footer, null, footer) : null);
};
ContextualMenu.propTypes = {
  /** The ref to which the contextual menu belongs */
  forRef: PropTypes.object.isRequired,
  /** Content inside contextual menu */
  children: PropTypes.node.isRequired,
  /** Use the Footer component from this package to stick content at the bottom of the contextual menu. */
  footer: PropTypes.node,
  /** Whether the contextual menu is open */
  open: PropTypes.bool,
  /** Whether the arrow is hidden, overlaid, or normal */
  arrow: PropTypes.oneOf(["none", "normal", "overlay"]),
  /** Handler for when a click occurs outside of the contextual menu (e.g., to close the callout) */
  onClickOutside: PropTypes.func
};
export default ContextualMenu;